export const EDU = {
    local: 'https://local.edu.portfolium.com',
    demo: 'https://edudemo.portfolium.com',
    production: 'https://edu.portfolium.com',
};
